<template>
  <div class="relative z-1">
    <saving-overlay
      :label="i18n.saving"
      v-if="saving"
      class="rounded-r rounded-bl"
    ></saving-overlay>
    <form @submit.prevent="save" class="p-5">
      <div class="flex">
        <div class="pr-1 flex-1">
          <div class="flex items-center justify-between w-full">
            <simple-radio
              :label="i18n.gender.label"
              v-model="form.gender"
              name="gender"
              :initial-value="personalData.gender"
              :required="true"
              :options="[
                {
                  id: 'man',
                  label: i18n.gender.man,
                },
                {
                  id: 'woman',
                  label: i18n.gender.woman,
                },
              ]"
              class="pr-2 w-1/2"
            ></simple-radio>
            <simple-radio
              :label="i18n.account_type.label"
              v-model="form.invoice_to"
              name="invoice_to"
              :initial-value="form.invoice_to"
              :required="true"
              :options="[
                {
                  id: '0',
                  label: i18n.account_type.individual,
                },
                {
                  id: '1',
                  label: i18n.account_type.company,
                },
              ]"
              class="pl-2 w-1/2"
            ></simple-radio>
          </div>

          <div class="flex items-center justify-between w-full">
            <simple-input
              :label="i18n.firstname"
              v-model="form.firstname"
              name="firstname"
              :required="true"
              class="w-1/2 pr-2"
            ></simple-input>

            <simple-input
              :label="i18n.lastname"
              v-model="form.lastname"
              name="lastname"
              :required="true"
              class="w-1/2 pl-2"
            ></simple-input>
          </div>

          <div class="flex items-center justify-between w-full">
            <simple-input
              class="w-1/2 pr-2"
              :label="i18n.company"
              v-model="form.company"
              :required="form.invoice_to == 1"
              name="company"
            ></simple-input>

            <simple-select
              class="w-1/2 pl-2"
              :label="i18n.user_activity"
              v-model="form.user_activity"
              name="user_activity"
              :required="true"
              :options="userActivities"
              v-if="userActivities !== undefined"
            ></simple-select>
          </div>
          <simple-input
            :label="i18n.vat.label"
            :labelInfo="i18n.vat.info"
            v-model="form.vat"
            :placeholder="i18n.vat.placeholder"
            name="vat"
          ></simple-input>

          <simple-input
            :label="i18n.address.street"
            v-model="form.add_main"
            name="add_main"
            :required="true"
          ></simple-input>

          <div class="flex items-center justify-between w-full">
            <simple-input
              :label="i18n.address.zipcode"
              v-model="form.add_zip"
              name="add_zip"
              :required="true"
              class="w-1/2 pr-2"
            ></simple-input>

            <simple-input
              :label="i18n.address.city"
              v-model="form.add_city"
              name="add_city"
              :required="true"
              class="w-1/2 pl-2"
            ></simple-input>
          </div>
          <div class="flex items-center justify-between w-full">
            <simple-input
              :label="i18n.address.state"
              v-model="form.add_state"
              name="add_state"
              :required="false"
              class="w-1/2 pr-2"
            ></simple-input>

            <simple-select
              :label="i18n.address.country"
              v-model="form.country_id"
              name="country_id"
              :required="true"
              :options="countries"
              v-if="countries !== undefined"
              class="w-1/2 pl-2"
            ></simple-select>
          </div>
          <div class="flex items-center justify-between w-full">
            <simple-input
              :label="i18n.email.address"
              :label-info="i18n.email.help"
              v-model="form.email"
              name="email"
              :disabled="true"
              class="w-1/2 pr-2"
            ></simple-input>
            <phone-number
              :label="i18n.phone.number"
              :help="i18n.phone.help"
              class="w-1/2 pl-2"
            ></phone-number>
          </div>
          <div class="flex items-center justify-end">
            <ranch-button
              type="submit"
              :label="i18n.save"
              icon="save"
            ></ranch-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { flash, handleAxiosError } from "@/boot/functions";

import { Form } from "../../../Utilities/Form";
import { mapState } from "vuex";
import SimpleInput from "../../../Design/Forms/SimpleInput";
import SimpleSelect from "../../../Design/Forms/SimpleSelect";
import SimpleRadio from "../../../Design/Forms/SimpleRadio";
import PhoneNumber from "../../../Design/Forms/PhoneNumber";
import SavingOverlay from "../../../Design/Forms/SavingOverlay";

export default {
  props: ["personalData"],
  components: {
    SimpleInput,
    SimpleSelect,
    SimpleRadio,
    PhoneNumber,
    SavingOverlay,
  },
  mixins: [],
  data: function () {
    return {
      saving: false,
      saved: false,
      form: new Form({
        gender: this.personalData.gender,
        invoice_to: this.personalData.invoice_to,
        firstname: this.personalData.firstname,
        lastname: this.personalData.lastname,
        company: this.personalData.company,
        vat: this.personalData.vat,
        user_activity: this.personalData.user_activity,
        add_main: this.personalData.add_main,
        add_zip: this.personalData.add_zip,
        add_city: this.personalData.add_city,
        add_state: this.personalData.add_state,
        country_id: this.personalData.country_id,
        genre: this.personalData.genre,
        phone_code: this.personalData.phone.code,
        phone_number: this.personalData.phone.number,
        email: this.personalData.email,
      }),
    };
  },
  methods: {
    save() {
      this.saving = true;
      this.form
        .post(this.endpoint)
        .then((data) => {
          // Save data in store
          this.$store.commit("account/setContact", data.data.contact);
          this.$store.commit("safe/setForm", data.data.contact);
          this.saving = false;
          this.saved = true;
          flash(this.i18n.saved, "success");
        })
        .catch(handleAxiosError)
        .then(() => {
          this.saving = false;
        });
    },
  },
  computed: {
    ...mapState({
      i18n: (state) => state.account.i18n.settings.personal_data.form,
      userActivities: (state) => state.formsData.userActivities,
      countries: (state) => state.formsData.countries,
    }),

    endpoint() {
      return this.$store.state.account.routes.updatePersonalData;
    },
  },
  mounted() {},
};
</script>
